import Typography from 'typography'

import {
  colours
} from '../theme'

const typography = new Typography({
  baseFontSize: '18px',
  baseLineHeight: 1.65,
  scaleRatio: 2.7,
  bodyFontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    'sans-serif',
  ],
  headerColor: colours.primary,
  bodyColor: "#111111",
  headerWeight: 700,
  bodyWeight: 400,
  boldWeight: 600,
  overrideStyles: ({
    adjustFontSizeTo,
    rhythm
  }, options, styles) => ({
    h1: {
		color: colours.primary,
		textAlign: 'center',
	},
	h2: {
		textAlign: 'center'
	},
	h3: {
		textAlign: 'center'
	}
  })
})

export default typography
